/**
 * Shared tenant constants for build configuration
 *
 * These constants are used by:
 * - Vite configuration files (vite.config.*.mts)
 * - Shared Vite utilities (configs/shared-vite/tenantConfig.ts)
 * - Tailwind configuration (tailwind.config.ts)
 *
 * NOTE: This file must remain independent (no imports from vega-core)
 * to avoid circular dependencies during the build process.
 *
 * Keep in sync with: packages/vega-core/src/constants/tenant.ts
 */

export const VALID_TENANTS = [
  "apollo",
  "ares",
  "carlyle",
  "celestial",
  "franklin",
  "ik-partners",
  "motive",
] as const;

export const DEFAULT_TENANT = "apollo";

export type TenantValue = (typeof VALID_TENANTS)[number];

export function isValidTenant(value: unknown): value is TenantValue {
  return (
    typeof value === "string" && VALID_TENANTS.includes(value as TenantValue)
  );
}
